"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHvacFilter = void 0;
const react_1 = require("react");
const mutations_1 = require("../../graphql/mutations");
const queries_1 = require("../../graphql/queries");
const amplifyBootstrap_1 = require("../../utils/amplifyBootstrap");
function useHvacFilter() {
    const requestService = (0, react_1.useCallback)(async (params) => {
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.requestFilterService,
                variables: { input: params },
            });
            return response.data?.requestFilterService;
        }
        catch (error) {
            console.error('Error requesting filter service:', error);
            throw error;
        }
    }, []);
    const clearAlert = (0, react_1.useCallback)(async (sensorId, hubId) => {
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.clearHvacFilterAlert,
                variables: { sensorId, hubId },
            });
            return response.data?.clearHvacFilterAlert;
        }
        catch (error) {
            console.error('Error clearing HVAC filter alert:', error);
            throw error;
        }
    }, []);
    const orderReplacementFilter = (0, react_1.useCallback)(async (params) => {
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.orderFilter,
                variables: { input: params },
            });
            return response.data?.orderFilter;
        }
        catch (error) {
            console.error('Error ordering replacement filter:', error);
            throw error;
        }
    }, []);
    const getFilterOrderStatus = (0, react_1.useCallback)(async (sensorId, hubId) => {
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.getHvacFilterOrderStatus,
                variables: { sensorId, hubId },
            });
            return response.data?.getHvacFilterOrderStatus;
        }
        catch (error) {
            console.error('Error getting filter replacement status:', error);
            throw error;
        }
    }, []);
    return {
        requestService,
        clearAlert,
        orderReplacementFilter,
        getFilterOrderStatus,
    };
}
exports.useHvacFilter = useHvacFilter;
exports.default = useHvacFilter;
